import { useState } from "react";
import RowBlock from "../row-block/row-block";
import TableHead from "../table-head/table-head";
import ModalInformation from '../modal-information/modal-information';
import { arrowDouble } from "../../ui-icons/icons";
import {
  AdditionalInformation,
  GroupRequirement,
  Department,
  AnswerContext
} from '../../types/data';
import { calculatesAverageValue, filteredAnswers } from '../../utils/utils';
import AlertInformation from "../alert-information/alert-information";
import { TooltipItem } from "src/utils/Tooltip";
import { getProductionDepartments } from "../../utils/data-table";

type TableProps = {
  data: GroupRequirement[];
  dataHead: Department[];
  isEvent?: boolean;
  answerContext: AnswerContext;
  isNotEditQuestionnaire: boolean;
  onCreateQuestionnaire: () => void;
  context?: any;
};

function Table({ data, dataHead, answerContext, onCreateQuestionnaire, isNotEditQuestionnaire, context }: TableProps) {
  const [showAllRow, setShowAllRow] = useState(false);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [currentInfo, setCurrentInfo] = useState<AdditionalInformation | null>(
    null,
  );

  const getClassName = (value: number | 'N/A') => {
    if (value === 'N/A') return 'bg-gray-200';
    if (value <= 59) return 'bg-pink-300';
    if (value >= 60 && value <= 69) return 'bg-yellow-300';
    if (value >= 70) return 'bg-green-300';
  };

  const handleToggleShowRow = () => {
    setShowAllRow(!showAllRow);
  };

  const handleOpenModal = (data?: AdditionalInformation) => {
    if (data) {
      setCurrentInfo(data);
    }

    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCloseModalAlert = () => {
    setModalOpenAlert(false);
  };

  const handleCloseModalError = () => {
    setModalOpenError(false);
  };

  return (
    <div className="no-outer-borders max-h-[calc(100vh-245px)] w-[100%] overflow-x-auto overflow-y-auto scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] rounded-md bg-[#F3F4F6] shadow">
      <table className="w-[100%] table-fixed border-collapse border bg-white">
        <TableHead isFixed data={dataHead} category="default" />

        <tbody>
          <tr>
            <td
              colSpan={4}
              onClick={handleToggleShowRow}
              className="sticky left-0 z-10 w-[100px] border border-gray-400 bg-white px-2.5 py-2 text-xs after:absolute after:bottom-[-1px] after:left-0 after:block after:w-full after:h-[1px] after:bg-gray-400 before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
            >
              <span className="text-sm font-medium">Общая оценка</span>
              <div
                className={`absolute right-3 top-[50%] translate-y-[-50%] ${showAllRow && 'rotate-180'}`}
              >
                <TooltipItem className={`${showAllRow ? 'rotate-180 translate-x-[-130%]' : ''}`} position="right" tooltipsText={showAllRow ? 'Свернуть все' : 'Развернуть все'}>
                  {arrowDouble}
                </TooltipItem>
              </div>
            </td>
            {dataHead.map((el) => (
              <td
                key={el.id}
                className={`border border-gray-400 px-2.5 py-2 text-center text-xs ${getClassName(calculatesAverageValue(data, el.title))}`}
              >
                {calculatesAverageValue(data, el.title)}
                {calculatesAverageValue(data, el.title) !== 'N/A' && '%'}
              </td>
            ))}
            <td
              className={`border border-gray-400 px-2.5 py-2 text-center text-xs ${getClassName(calculatesAverageValue(filteredAnswers(data, getProductionDepartments(dataHead)), undefined, true))}`}
            >
              {calculatesAverageValue(filteredAnswers(data, getProductionDepartments(dataHead)), undefined, true)}
              {calculatesAverageValue(
                filteredAnswers(data, getProductionDepartments(dataHead)),
                undefined,
                true,
              ) !== 'N/A' && '%'}
            </td>
            <td
              className={`border border-gray-400 px-2.5 py-2 text-center text-xs ${getClassName(calculatesAverageValue(data, undefined, true))}`}
            >
              {calculatesAverageValue(data, undefined, true)}
              {calculatesAverageValue(data, undefined, true) !== 'N/A' && '%'}
            </td>
          </tr>

          {data.map(({ title, groupRequirements, }, index) => (
            <RowBlock
              key={index}
              title={title}
              category="default"
              departments={dataHead}
              groupRequirements={groupRequirements}
              showContent={showAllRow}
              onOpenModal={handleOpenModal}
              isCompleted={isNotEditQuestionnaire}
              answerContext={answerContext}
              onCreateQuestionnaire={onCreateQuestionnaire}
              context={context}
            />
          ))}
        </tbody>
      </table>

      <ModalInformation
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        data={currentInfo}
      />
    </div>
  );
}

export default Table;
